import React from 'react';
import PropTypes from 'utils/propTypes';

import classNames from 'classnames';

import {
  Card,
  CardTitle,
  CardSubtitle,
  CardText,
  CardBody,
} from 'reactstrap';

import {
  FaSignOut,
} from 'react-icons/lib/fa';

const UsuarioPerfil = ({
  avatar,
  avatarSize,
  nome,
  email,
  cpf,
  cliente,
  ip,
  ultimoAcesso,
  className,
  ...restProps
}) => {
  const classes = classNames('info-user', className);

  return (
  
    <Card inverse className={classes} {...restProps}>
      <CardBody className="d-flex flex-column">
        <span className="icon-quepe-info"></span>
        <FaSignOut className="icon-logout" onClick={e => window.location.replace("/services/logout")}/>
        <CardTitle className="title-orgao"> {cliente} </CardTitle>
        <CardSubtitle> {nome} </CardSubtitle>
        <CardText>
          <small className="title-operador">IP: {ip}</small>
          <small className="title-operador">Último acesso: {new Date(ultimoAcesso).toLocaleString()}</small>
        </CardText>
      </CardBody>
    
    </Card>
  );
};

UsuarioPerfil.propTypes = {
  avatar: PropTypes.string,
  avatarSize: PropTypes.number,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
};

UsuarioPerfil.defaultProps = {
  avatarSize: 80,
};

export default UsuarioPerfil;



// WEBPACK FOOTER //
// ./src/componentes/usuario/UsuarioPerfil.js